enum FlashMessageTypeEnum {
  ERROR = 'danger',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning'
}

export default FlashMessageTypeEnum;
